// extracted by mini-css-extract-plugin
export const wrapper = "timeline-module--wrapper--3HLJQ";
export const timeline = "timeline-module--timeline--1a5o9";
export const timelineContainer = "timeline-module--timelineContainer--2ieDT";
export const timelineYear = "timeline-module--timelineYear--24XWf";
export const timelineBody = "timeline-module--timelineBody---xomZ";